export function initDealsSubmenu() {
  const toggle = document.getElementById('dealsNavToggle');
  const group = toggle?.closest('.dashboard-nav-group');

  if (!toggle || !group) return;

  toggle.addEventListener('click', () => {
    const isOpen = group.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
}